import classNames, { Argument as ClassNameArgument } from "classnames";
import React, { CSSProperties, FC } from "react";
import styles from "./column.scss";


export const Column: FC<{
    fit?: "none" | "width" | "height" | "both";
    center?: boolean;
    middle?: boolean;
    spacing?: "none" | "normal" | "narrow" | "wide";
    className?: ClassNameArgument;
    style?: CSSProperties;
    children: React.ReactNode;
}> =
    ({ fit, center, middle, spacing, className, style, children }) =>
    {
        fit = fit ?? "width";
        spacing = spacing ?? "normal";
        return (
            <div
                className={
                    classNames(
                        styles.column,
                        (fit != "none") && styles[`fit-${fit}`],
                        center && styles.center,
                        middle && styles.middle,
                        (spacing != "none") && styles[`spacing-${spacing}`],
                        className
                    )
                }
                style={style}
            >
                {children}
            </div>
        );
    };
